<template>
  <ul class="menu">
    <li @click="$router.push({name: 'sobre nosotros'})">
      <img
        src="../assets/sobre-nosotros-icon.svg"
        class="mr-2"
        alt=""
      >SOBRE NOSOTROS
    </li>
    <li @click="$router.push({name: 'contact form with ana'})">
      <img
        src="../assets/contactos-icon.svg"
        class="mr-2"
        alt=""
      >CONTACTOS
    </li>
    <li>
      <a
        href=""
        class="registrarse-btn"
      >REGISTRARSE <img
        class="ml-2"
        src="../assets/registrarse-icon.svg"
        alt=""
      ></a>
    </li>
    <li>
      <a
        href=""
        @click.stop.prevent="$router.push('/explorar_carreras')"
      ><u>INICIAR SESIÓN</u></a>
    </li>
  </ul>
</template>

<script>
export default {
    name: 'MainMenu',
};
</script>

<style lang="scss" scoped>

.menu {
  margin: 0 0 2rem 0;
  padding: 0;
  display: none;

  @media screen and (min-width: 660px) {
    display: flex;
    justify-content: flex-end;
  }
  li {
    cursor: pointer;
    display: inline-flex;
    font-size: 0.75rem;
    height: 37px;
    align-items: center;
    padding: 0 0.5rem;
  }
}

.registrarse-btn{
  width: 148px;
  border-radius: 8px;
  height: 37px;
  background-color: #2e89df;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  &:hover{
    text-decoration: none;
    color: white;
    background-color: lighten(#2e89df, 10);
  }

}
</style>
